import { AxiosResponse } from "axios";

import { Shipment, ReceivedProduct, ShipmentMailPayload, CompanyEmailSentShipment } from "../models/shipments";

import API from "../api";
import API_BLOB from "../api/indexBlob";

import { Milestone } from "../models/milestone";

import { GetAndCountAll } from "./_base";
import { ShipmentsTracking } from "../models/shipments/shipments.tracking";
import { Network } from "../models/network";

const ROUTE_NAME = "shipments";

const ShipmentService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },

  async getById(id: number, options?: any): Promise<AxiosResponse<Shipment>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getExportById(id: number, options?: any): Promise<AxiosResponse<Shipment[]>> {
    return await API.get(`/${ROUTE_NAME}/export/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async getAllNetwork(options?: any): Promise<AxiosResponse<GetAndCountAll<Shipment>>> {
    return await API.get(`/${ROUTE_NAME}/network`, { params: options });
  },
  async getNetworkInfos(options?: any): Promise<AxiosResponse<Network[]>> {
    return await API.get(`/${ROUTE_NAME}/network/info`, { params: options });
  },
  async getHistoryV2(id: number): Promise<AxiosResponse<any>> {
    return await API.get(`/v2/${ROUTE_NAME}/histories/${id}`);
  },

  // temporary endpoint to test shipment ms
  async create(shipment: any): Promise<AxiosResponse<any>> {
    return await API.post(`/v3/${ROUTE_NAME}`, shipment);
  },
  async update(id: number, agent: any): Promise<AxiosResponse<any>> {
    return await API.put(`/v3/${ROUTE_NAME}/${id}`, agent);
  },

  // use if need send work to deploy
  async createV2(shipment: any): Promise<AxiosResponse<any>> {
    return await API.post(`/v2/${ROUTE_NAME}`, shipment);
  },
  async updateV2(agent: any): Promise<AxiosResponse<any>> {
    return await API.put(`/v2/${ROUTE_NAME}`, agent);
  },

  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async import(file: any, userId: string): Promise<AxiosResponse<any>> {
    return await API_BLOB.post(`/${ROUTE_NAME}/upload/csv/${userId}`, file);
  },
  async export(shipId: number | string): Promise<AxiosResponse<Shipment[]>> {
    return await API_BLOB.get(`/${ROUTE_NAME}/export/${shipId}`);
  },
  async getReceivedProducts(containerId: string): Promise<AxiosResponse<ReceivedProduct[]>> {
    return await API.get(`/${ROUTE_NAME}/getReceivedShipmentByContainerID/${containerId}/true`);
  },
  async getMilestoneDates(options?: any): Promise<AxiosResponse<Milestone[]>> {
    return await API.get(`/${ROUTE_NAME}/milestones`, { params: options });
  },

  async getBookingFile(shipmentId: number): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/reports/booking/file`, { shipmentId });
  },
  async getBookingFiles(shipmentList: number[]): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/reports/booking/file/zip`, { shipmentList });
  },

  async getAllShipmentTracking(options?: any): Promise<AxiosResponse<ShipmentsTracking[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },

  async receivedAllBookings(bookingIds: number[]): Promise<AxiosResponse<any>> {
    return await API.put(`/v3/${ROUTE_NAME}/receive/bookings`, { bookingIds });
  },

  async getShipmentTrackingById(
    id: number,
    options?: any
  ): Promise<AxiosResponse<ShipmentsTracking>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },

  async cancelBooking(id: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/cancel/${id}`);
  },
  async sendMail(mail: ShipmentMailPayload): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/mail`, mail);
  },
  
  async getAvailableEmails(options?: any): Promise<AxiosResponse<CompanyEmailSentShipment[]>> {
    return await API.get(`/${ROUTE_NAME}/emails/available`, { params: options });
  },
};

export default ShipmentService;
